import React, {useEffect, useState} from 'react';
import { Transition } from 'react-transition-group';
import * as SS from '../styles/shared-styles';
import Lottie from 'lottie-web';
import FloatingGrades from './floating-grade-selection';
import addPropertiesAsSuperToTracker from '../../../utils/add-super-props';
import i18n from '../../../utils/i18n';
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { setSelectedGrade, setSelectedSubject } from '../../../stores/splashverse-onboarding/actions';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { IsElaAvailabeForGrade } from '../helper/helper';
import { TrackUserActionAnalytics } from '../../../services/loggedout-api';
import { gradesToSkipSubjectFor } from '../../../constant-data/splashverse-onboarding';
import { SetGradeApi,FetchNewABTests } from '../../../services/parent-api';
import { getCookie, setCoachmarkFlag, sendErrorToSentry, assignAbTestsToUser ,convertToUUIDFormat} from '../../../utils/web-helper';
import { setNewABTests } from '../../../utils/ab-tests';
import { PRE_K_GRADE, K_GRADE } from '../../../constant-data/constants';

const GradeSelection = ({isNextStep, goToNextHandler, students, currentUser}) => {

  const { childScreenName, subjectGradeMap, gradeCodeMap, skipSubject, skipPOQ, isLPABTest } = useSelector(state => state, shallowEqual);

  const [animate, setAnimate] = useState(false);
  const [selectedGrade, setGrade] = useState('');
  const [headerTransition, setHeaderTransition] = useState(undefined);

  const { setValue, deleteAll } = useExtendedLocalStorage('splashverse-onboarding', '');
  const dispatch = useDispatch();


  useEffect(() => {
    setCoachmarkFlag();
    setTimeout(() => {
      setAnimate(true);
    }, 100);
  }, []);

  const gradeSelectionHandler = async (code, animationData) => {
    try {
      addPropertiesAsSuperToTracker({
        'Grade': code
      });
      trackAnalyticsEvent("Interacted Grade Selection", { 'Clicked On': "Grade" });
      TrackUserActionAnalytics({
        user_action: 'grade_select',
        action_info: {
          grade_code: code
        }
      }, true);
      doHeaderTransition();
      setGrade(i18n.t(`loggedout-grade.${code}`));
      Lottie.destroy('gradeSelection')
      const animationContainer = Lottie.loadAnimation({
        container: document.getElementById('grade-animation-wrapper'),
        animationData: animationData,
        loop: false,
        renderer: 'svg',
        name: 'grade' + code,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice', // Supports the same options as the svg element's
        }
      })
      animationContainer.addEventListener('complete', () => gradeSelectionSuccessCallback(code))
    } catch (e) {
      console.log(e)
    }
  }

  const gradeSelectionSuccessCallback = async (code) => {
    let opt = {};
    let eligibleGradeForAgeScreen = [PRE_K_GRADE, K_GRADE];
    const gradeId = gradeCodeMap.get(code).id;
    let isElaAvailabeForGrade = IsElaAvailabeForGrade(gradeId, subjectGradeMap);

    if (skipSubject) {
      if (
        isElaAvailabeForGrade &&
        (getCookie('oddbods') || gradesToSkipSubjectFor.indexOf(code) != -1)
      ) {
        setValue('selectedSubject', 'ela');
        dispatch(setSelectedSubject('ela'));
        opt = { selectedSubject: 'ela' };
      } else {
        setValue('selectedSubject', 'math');
        dispatch(setSelectedSubject('math'));
        opt = { selectedSubject: 'math' };
      }
    }

    opt = {
      ...opt,
      isPreKAndK: eligibleGradeForAgeScreen.includes(code),
      skipSubject, isElaAvailabeForGrade, skipPOQ,code, deleteAll

    }
    setValue('selectedGrade', code);
    dispatch(setSelectedGrade(code));
    //api call to set grade
    try {
      const resp = await SetGradeApi({
        grade_code: code,
        student_id: students && students.length && students[0].id ? students[0].id : null,
        onboarding: true,
        screen_name: childScreenName,
      });

      const abResp = await assignAbTestsToUser(currentUser?.id, code);

      const newAbTests = await FetchNewABTests({userId:convertToUUIDFormat(currentUser?.id)});
      setNewABTests(newAbTests?.assigned_ab_tests)

      const childId =  resp && resp.student && resp.student.id || students && students.length && students[0].id;
      // //set child id in local storage
      childId && setValue('childId',childId);

      setValue('isLPABTest', isLPABTest);

     // const isLiveClassesABTestAssigned = true; //i ntegrate it with AB test

     // if(isLiveClassesABTestAssigned){
     //   opt["isLiveClasses"] = true;
     // }
     return goToNextHandler('grade_selection', opt);


    // if (isLPABTest) {
    //   return goToNextHandler('grade_selection', opt);
    // } else {
    //   return redirectToDashboard( });
    // }

  }catch(err){
    console.error(err);
    let errorInfo = {
      extraMsg: 'SetGradeApi failed',
    };
    sendErrorToSentry(err, errorInfo)
  }
}

  const doHeaderTransition = () => {
    setHeaderTransition(false);
    setTimeout(() => {
      setHeaderTransition(true);
    }, 700);
  }

  return (
    <Transition in={animate} timeout={500}>
      {(state) => (
        <SS.OnboardingStepWrapper state={state} isNextStep={isNextStep}>
          <SS.StepHeader showTransition={headerTransition}>
            { selectedGrade || `What ${i18n.t('onboarding.grade.grade')} is ${childScreenName || 'your child'} in?`}
          </SS.StepHeader>
          {!selectedGrade && <SS.StepSubheader>
            {`We’ll curate ${childScreenName || 'your child'}’s learning universe based on this`}
          </SS.StepSubheader>}
          <FloatingGrades gradeSelectionHandler={gradeSelectionHandler} />
          <SS.Footer>{`You can always change the ${i18n.t('onboarding.grade.grade')} later if you think ${childScreenName || 'your child'} needs a different level of learning challenges`}</SS.Footer>
        </SS.OnboardingStepWrapper>
      )}
    </Transition>
  )
}

export default GradeSelection;